import { Box, type BoxProps, forwardRef } from '@chakra-ui/react-v2';

import { useEmptyStyles } from './EmptyStylesContext';

export type EmptyHeadlineProps = BoxProps;

/**
 * A title used to describe an empty state condition. Part of the multipart `Empty` component. Composes `Box`.
 */
export const EmptyHeadline = forwardRef<EmptyHeadlineProps, 'div'>(
  ({ children, ...restProps }, ref) => {
    const { headline: headlineStyles } = useEmptyStyles();

    return (
      <Box ref={ref} __css={headlineStyles} {...restProps}>
        {children}
      </Box>
    );
  },
);
EmptyHeadline.displayName = 'EmptyHeadline';
